// Thread identity and legacy-vendor resolution for order courier conversations.
export type OrderChatOrder = { id: string; vendorId?: string; items?: { vendorId?: string }[] };
export type OrderChatMessage = { vendorId?: string; senderId?: string; senderRole: string; channel?: string };

export function getOrderVendorIDs(order: OrderChatOrder): string[] {
  return Array.from(new Set([order.vendorId, ...(order.items ?? []).map((item) => item.vendorId)]
    .map((id) => String(id ?? "").trim()).filter(Boolean)));
}

export function getEffectiveOrderVendorID(order: OrderChatOrder, message: OrderChatMessage): string | undefined {
  if (message.channel === "courier_buyer") return undefined;
  if (message.vendorId) return message.vendorId;
  const vendors = getOrderVendorIDs(order);
  if (vendors.length === 1) return vendors[0];
  if (message.senderRole === "seller" && message.senderId && vendors.includes(message.senderId)) return message.senderId;
  return undefined;
}

export function getOrderSellerConversationKey(order: OrderChatOrder): string {
  return `order:${order.id}:vendor:${order.vendorId ?? ""}`;
}

export function getCourierConversationKey(order: OrderChatOrder): string {
  return `order:${order.id}`;
}
